import { useQuery } from '@tanstack/react-query';
import { createSubscriptionDoc } from 'shared/lib/@tanstack-query';
import { getFcmTokenDoc } from 'shared/services/backend-api';

export const queryKey = 'fcm-token-doc';

export const useFcmTokenDocQuery = (token?: string | null) =>
  useQuery({
    queryKey: [queryKey, token ?? ''],
    queryFn: createSubscriptionDoc(() => getFcmTokenDoc(token!)),
    enabled: !!token,
  });
